import * as React from 'react';
import { CalciteInputNumber } from '@esri/calcite-components-react';
import { undefBool } from '../../../util/webComponentUtils';
import { useEditorFocus } from './useEditorFocus';

const IntegerCellEditor: CellEditor = ({
  value,
  onChange,
  disabled,
  readOnly,
  autoEdit,
}) => {
  const ref = useEditorFocus<HTMLCalciteInputNumberElement>((el) => {
    el.setFocus();
    el.selectText();
  }, autoEdit);

  return (
    <CalciteInputNumber
      ref={ref}
      value={value}
      onCalciteInputNumberInput={(e) =>
        onChange(String(Number.parseInt(e.target.value)))
      }
      disabled={undefBool(disabled)}
      placeholder="123"
      readOnly={undefBool(readOnly)}
      autofocus
    />
  );
};

export default IntegerCellEditor;
